<template>
  <div class="index" v-cloak>
    <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner.length > 0">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <img :src="item.pic" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="address">
      <div>
        <img src="@assets/images/icon-9.png" /> {{market.name}}
      </div>
      <div>
        <img src="@assets/images/icon-10.png" /> {{market.address}}
      </div>

      <div>
        <img src="@assets/images/icon-11.png" /> {{market.tel}}
      </div>
    </div>


    <div class="wrapper">
      <div class="title acea-row row-between-wrapper">
        <div class="nav acea-row row-middle">
          <div class="item">人气</div>

          <div class="item" @click="set_where(2)">
            销量
           
          </div>
          <div class="item" @click="set_where(1)">
            价格
            <img src="@assets/images/horn.png" v-if="price === 0" />
            <img src="@assets/images/up.png" v-if="price === 1" />
            <img src="@assets/images/down.png" v-if="price === 2" />
          </div>
          <!-- down -->
        </div>
      </div>

      <Good-list :good-list="info" :is-sort="false"></Good-list>
    </div>

    <Coupon-window
      :coupon-list="couponList"
      v-if="showCoupon"
      @checked="couponClose"
      @close="couponClose"
    ></Coupon-window>
    <div style="height:1.2rem;"></div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
import PromotionGood from "@components/PromotionGood";
import CouponWindow from "@components/CouponWindow";
import { getMarketData, getShare } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAppMessage, openShareTimeline, ready } from "@libs/wechat";
import { isWeixin } from "@utils/index";

const HAS_COUPON_WINDOW = "has_coupon_window";

export default {
  name: "ATM",
  components: {
    swiper,
    swiperSlide,
    GoodList,
    PromotionGood,
    CouponWindow
  },
  props: {},
  data: function() {
    return {
      banner: [],
      market: {},
      price: 0,
      stock: 0,
      where: {
        page: 1,
        limit: 8,
        keyword: "",
        priceOrder: "",
        salesOrder: ""
      },
      info: [],
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      }
    };
  },
  mounted: function() {
    var market = this.$route.query.type;
    if (market != undefined) {
      sessionStorage.setItem("market", market);
    } else {
      market = sessionStorage.getItem("market");
    }

    let that = this;
    var params = { market: market };
    getMarketData(params).then(res => {
      that.logoUrl = res.data.logoUrl;
      that.$set(that, "market", res.data.market);
      that.$set(that, "banner", res.data.banner);
      that.$set(that, "info", res.data.info);
      that.setOpenShare();
    });
  },
  watch: {
    $route(to, from) {
      var market = this.$route.query.type;
      if (market != undefined) {
        sessionStorage.setItem("market", market);
      } else {
        market = sessionStorage.getItem("market");
      }

      let that = this;
      var params = { market: market };
      getMarketData(params).then(res => {
        that.logoUrl = res.data.logoUrl;
        that.$set(that, "market", res.data.market);
        that.$set(that, "banner", res.data.banner);
        that.$set(that, "info", res.data.info);
      });
    }
  },
  methods: {
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    //点击事件处理
    set_where: function(index) {
      let that = this;
      switch (index) {
        case 0:
          return that.$router.push({ path: "/category" });
        case 1:
          if (that.price === 0) that.price = 1;
          else if (that.price === 1) that.price = 2;
          else if (that.price === 2) that.price = 0;
          that.stock = 0;
          break;
        case 2:
          if (that.stock === 0) that.stock = 1;
          else if (that.stock === 1) that.stock = 2;
          else if (that.stock === 2) that.stock = 0;
          that.price = 0;
          break;
        case 3:
          that.nows = !that.nows;
          break;
        default:
          break;
      }
      that.where.page = 1;
      that.loadend = false;

      var market = this.$route.query.type;
      if (market != undefined) {
        sessionStorage.setItem("market", market);
      } else {
        market = sessionStorage.getItem("market");
      }
      var price=that.price==2?"desc":"asc";
      var q={market:market,priceOrder:price}
       console.log(q)
      getMarketData(q).then(res => {
        that.$set(that, "info", res.data.info);
      });
    },
    setOpenShare: function() {
      getShare().then(res => {
        var data = res.data.data;
        var configAppMessage = {
          desc: data.synopsis,
          title: data.title,
          link: location.href,
          imgUrl: data.img
        };
        var configTimeline = {
          title: data.title,
          link: location.href,
          imgUrl: data.img
        };
        if (isWeixin() === true) {
          ready().then(() => {
            openShareAppMessage(configAppMessage).then(() => {});
            openShareTimeline(configTimeline).then(() => {});
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.index {
  background-color: #fff;
}
.address {
  display: flex;
  flex-flow: column;
  padding: 0.3rem;
}
.address img {
  width: 14px;
}
.nav {
  height: 0.86rem;
  color: #454545;
  width: 100%;
  font-size: 0.28rem;
  display: flex;
  justify-content: center;
}
.nav .item {
  width: 33%;
}
.nav .item img {
  width: 0.15rem;
  height: 0.19rem;
  margin-left: 0.1rem;
}
</style>
